var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "KFocusTrap",
    {
      on: {
        shouldFocusFirstEl: _vm.focusFirstEl,
        shouldFocusLastEl: _vm.focusLastEl,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "onboarding-tooltip",
          attrs: { role: "dialog", "aria-modal": "true" },
        },
        [
          _c("h1", { staticClass: "visuallyhidden" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.onboardingStepDescription$({
                    pageTitle: _vm.getTranslatedPageLabel(),
                    currentStep: _vm.currentStepIndex + 1,
                    totalSteps: _vm.steps.length,
                  })
                ) +
                "\n    "
            ),
          ]),
          _c(
            "div",
            { staticClass: "onboarding-tooltip-header" },
            [
              _c(
                "div",
                { staticClass: "onboarding-tooltip-progress" },
                _vm._l(_vm.steps, function (step, index) {
                  return _c("span", {
                    key: index,
                    staticClass: "dot",
                    style: {
                      backgroundColor:
                        index === _vm.currentStepIndex
                          ? _vm.$themeBrand.primary.v_500
                          : _vm.$themePalette.grey.v_300,
                    },
                  })
                }),
                0
              ),
              _c("KIconButton", {
                ref: "closeButton",
                attrs: {
                  icon: "close",
                  ariaLabel: _vm.coreString("closeAction"),
                  tooltip: _vm.coreString("closeAction"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "onboarding-tooltip-body" }, [
            _c("p", { attrs: { id: "tooltip-title" } }, [
              _vm._v(_vm._s(_vm.steps[_vm.currentStepIndex].content())),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "onboarding-tooltip-footer" },
            [
              _vm.currentStepIndex > 0
                ? _c(
                    "KButton",
                    {
                      ref: "backButton",
                      attrs: {
                        "data-back-btn": "backButton",
                        primary: false,
                        appearance: "flat-button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("back")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.coreString("backAction")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _c("KButton", {
                ref: "continueButton",
                attrs: {
                  "data-continue-btn": "continueButton",
                  secondary: "",
                  text:
                    _vm.currentStepIndex === _vm.steps.length - 1
                      ? _vm.coreString("finishAction")
                      : _vm.coreString("continueAction"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("next")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }